import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { useLanguage } from '../../../../context/language/language';
import { TitleModal } from '../../../MyAccount/common';
import { choiceSelectionModalSize } from '../modalSize';
import ClockInfoIcon from '../../../../medias/icon/Component/ClockInfoIcon';
import { getStoreOpenTimeLocal, getStoreOpenTime } from '../../../../utils/utils';
import { getImageURL } from '../../../../utils/getImageURL';
import Display from '../../../common/Display';
import {
  selectCheckoutState,
  selectPreCheckoutState
} from '../../../../store/cart/selector';
import useCheckout from '../../../common/hook/useCheckout';
import useDeliveryData from '../../../common/hook/useDeliveryData';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';
import { useSite } from '../../../../context/siteContext';
import { ModalInfo } from '../../../common';

const ClockIcon = getImageURL('/icon/clock-unavailable.svg');
const CustomTitleModal = styled(TitleModal)(({ theme }) => ({
  ...theme.fonts.header3,
}));

const BtnCancel = styled(Button)(({ theme }) => ({
  width: '100%',
  marginRight: 8,
  backgroundColor: theme.colors.grey75,
  height: 44,
  textTransform: 'none',
  ...theme.radius.m,
  ...theme.fonts.header6,
}));

const BtnSubmit = styled(Button)(({ theme, disabled }) => ({
  width: '100%',
  backgroundColor: theme.colors.green600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  height: 44,
  textTransform: 'none',
  ...theme.radius.m,
  ...theme.fonts.header6,

  '&:hover': {
    backgroundColor: theme.colors.green400,
  },
}));

const useStyle = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('md')]: {
      width: choiceSelectionModalSize.width,
      padding: 24,
      boxSizing: 'border-box',
    },
  },
  icon: {
    width: 64,
    height: 64
  }
}));

function StoreCloseWarningDialog(props) {
  const word = useLanguage();
  const classes = useStyle();
  const { MySite, ThSite } = useSite();
  const checkout = useCheckout();
  const warningStoreOpenTimeLocal = getStoreOpenTimeLocal();
  const warningStoreOpenTime = getStoreOpenTime();
  const deliveryControl = useDeliveryControlFlow();
  const { activeDeliveryType } = useDeliveryData();
  let detailText = '';
  if (warningStoreOpenTimeLocal.isClose) {
    detailText = word('Store.OpenHour.Closed.Description').replace(/%s/g, warningStoreOpenTimeLocal.time);
  }
  if (warningStoreOpenTime.isClose) {
    detailText = word('Store.OpenHour.Closed.Description').replace(/%s/g, warningStoreOpenTime.time);
  }
  // Open store close warning
  if (checkout.hadFailure && checkout.errorCode === 40066) {
    const timeStr = `${checkout.errorDetail.storeOpenAt ?? ''} - ${checkout.errorDetail.storeCloseAt ?? ''}`;
    detailText = word('Store.OpenHour.Closed.Description').replace(/%s/g, timeStr);
  }

  const NewLineText = (text) => (_.isString(text) ? text?.replace(/\\n/g, '<br/>') : text);

  return (
    <ModalInfo
      isOpen={deliveryControl.showModal}
      title={word('Store.OpenHour.Closed.Title')}
      description={<div dangerouslySetInnerHTML={{ __html: NewLineText(detailText) }} />}
      type="info"
      showCancel
      showIcon
      customIcon={<img src={ClockIcon} className={classes.icon} />}
      cancelText={word('General.Cancel')}
      labelText={word('Store.OpenHour.Closed.ChangeDelivery')}
      onClose={props.onBack}
      onConfirm={props.onNext}
    />
  );

}

export default StoreCloseWarningDialog;
